'use strict';

(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const { routes, strings } = window.theme;
  const cartSection = 'cart-drawer';
  let toastTimer;

  function toast(message) {
    const el = $('#toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2500);
  }

  /* ---------- Cart drawer ---------- */

  const drawer = () => $('#cart-dialog');

  function openDrawer() {
    const d = drawer();
    if (d && !d.open) d.showModal();
  }

  function renderCart(sections, itemCount) {
    const html = sections && sections[cartSection];
    if (html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-dialog');
      const current = drawer();
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    if (typeof itemCount === 'number') $$('[data-cart-count]').forEach((el) => { el.textContent = itemCount; });
  }

  async function cartRequest(url, body) {
    const d = drawer();
    if (d) d.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: cartSection, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || strings.error);
      return data;
    } finally {
      if (d) d.removeAttribute('aria-busy');
    }
  }

  async function addToCart(items) {
    try {
      const data = await cartRequest(`${routes.cartAdd}.js`, { items });
      if (window.theme.cartType === 'page') {
        window.location.href = routes.cart;
        return true;
      }
      const cart = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      renderCart(data.sections, cart.item_count);
      toast(strings.added);
      openDrawer();
      return true;
    } catch (err) {
      toast(err.message || strings.error);
      return false;
    }
  }

  async function changeLine(line, quantity) {
    try {
      const data = await cartRequest(`${routes.cartChange}.js`, { line, quantity: Math.max(0, Math.min(99, quantity)) });
      renderCart(data.sections, data.item_count);
    } catch (err) {
      toast(err.message || strings.error);
    }
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      drawer().close();
      return;
    }
    const qty = e.target.closest('#cart-dialog [data-line]');
    if (qty) {
      changeLine(Number(qty.dataset.line), Number(qty.dataset.quantity));
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      quick.disabled = true;
      addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]).finally(() => { quick.disabled = false; });
    }
  });

  // Close the drawer when clicking the backdrop.
  document.addEventListener('click', (e) => {
    const d = drawer();
    if (!d || e.target !== d) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  });

  /* ---------- Product page ---------- */

  const section = $('[data-product-section]');
  if (section) {
    const variants = JSON.parse($('[data-variants]', section).textContent);
    const preorder = JSON.parse($('[data-preorder]', section).textContent);
    const form = $('[data-product-form]', section);
    const select = $('[data-variant-select]', section);
    const button = $('[data-add-button]', section);
    const mainImage = $('[data-main-image]', section);

    const showImage = (src) => {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
    };

    if (select) {
      select.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === select.value);
        if (!v) return;
        $('[data-price]', section).textContent = v.price;
        const compare = $('[data-compare]', section);
        if (compare) {
          compare.textContent = v.compare || '';
          compare.hidden = !v.compare;
        }
        const stock = $('[data-availability]', section);
        stock.textContent = v.available ? `${strings.inStock}${preorder ? ` · ${strings.preorder}` : ''}` : strings.soldOut;
        stock.classList.toggle('sold', !v.available);
        button.disabled = !v.available;
        button.textContent = v.available ? (preorder ? strings.preorderNow : strings.addToCart) : strings.soldOut;
        if (v.image) showImage(v.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      });
    }

    $$('[data-thumb]', section).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showImage(thumb.dataset.thumb);
        $$('[data-thumb]', section).forEach((t) => t.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    form.addEventListener('submit', async (e) => {
      if (window.theme.cartType === 'page') return;
      e.preventDefault();
      const data = new FormData(form);
      button.disabled = true;
      await addToCart([{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }]);
      const v = variants.find((x) => String(x.id) === String(data.get('id')));
      button.disabled = v ? !v.available : false;
    });
  }

  /* ---------- Catalog: auto-submit filters, load more ---------- */

  $$('[data-catalog-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-auto-submit]')) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
    // Drop empty params so URLs stay clean.
    form.addEventListener('formdata', (e) => {
      for (const [key, value] of [...e.formData.entries()]) if (value === '') e.formData.delete(key);
    });
  });

  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    more.setAttribute('aria-busy', 'true');
    try {
      const html = await fetch(more.href).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-product-grid]');
      $$('[data-product-grid] > *', doc).forEach((card) => grid.append(card));
      const next = $('[data-load-more]', doc);
      if (next) {
        more.href = next.href;
        more.removeAttribute('aria-busy');
      } else {
        more.remove();
      }
    } catch {
      window.location.href = more.href;
    }
  });

  /* ---------- Header: mobile menu, search shortcut ---------- */

  const menuToggle = $('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      const nav = $('#main-nav');
      const open = nav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open);
    });
  }

  document.addEventListener('keydown', (e) => {
    const typing = ['INPUT', 'SELECT', 'TEXTAREA'].includes(document.activeElement.tagName);
    if (e.key === '/' && !typing && !document.querySelector('dialog[open]')) {
      e.preventDefault();
      const inline = $('[data-search-input]');
      if (inline) {
        inline.focus();
        return;
      }
      const details = $('.header-search');
      if (details) {
        details.open = true;
        $('input[type=search]', details).focus();
      }
    }
    if (e.key === 'Escape') {
      const nav = $('#main-nav');
      if (nav) nav.classList.remove('open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      const details = $('.header-search[open]');
      if (details) details.open = false;
    }
  });

  // Address forms: select the saved country (Shopify's country tags have no selected option).
  $$('select[data-default]').forEach((select) => {
    const saved = select.dataset.default;
    if (saved && [...select.options].some((o) => o.value === saved)) select.value = saved;
  });

  // Login page: show the reset form.
  const recoverLink = $('[data-toggle-recover]');
  if (recoverLink) {
    recoverLink.addEventListener('click', (e) => {
      e.preventDefault();
      $('#recover').classList.toggle('open');
    });
  }
})();
